import { render, staticRenderFns } from "./commitupdate.vue?vue&type=template&id=cd740922"
import script from "./commitupdate.vue?vue&type=script&lang=js"
export * from "./commitupdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports